/**
 * AIカラーシミュレーションの権限管理
 *
 * SimulationDetailコンポーネントはcompany/customerの両方で使用される。
 * roleを渡すことで、各機能の表示/非表示をコンポーネント側で制御する。
 */

/** ユーザーロール */
export type SimulationRole = 'company' | 'customer'

/** 権限定義 */
export interface SimulationPermissions {
  /** カスタムエリアの描画・追加が可能か */
  canEditCustomArea: boolean
  /** 除外エリアの描画・追加が可能か */
  canEditExcludeArea: boolean
  /** 案件名の編集が可能か */
  canEditDealName: boolean
  /** 画像のアップロード（新規外観カット追加）が可能か */
  canUploadImage: boolean
  /** 画像の削除が可能か */
  canDeleteImage: boolean
  /** 共有リンクの生成が可能か */
  canShare: boolean
  /** マスクの再生成が可能か */
  canRegenerateMask: boolean
  /** カスタムエリアの設定ダイアログが使用可能か */
  canConfigureCustomArea: boolean
  /** 屋根・外壁ベースエリアでの素材選択が可能か (Issue #1785) */
  canEditMaterial: boolean
  /** 色指定ダイアログでプリセットを選択できるか（企業のみ。施主は企業指定に拘束される） */
  canSelectPreset: boolean
  /** 履歴のピン留めを付け外しできるか（企業のみ。施主は見るだけ。issue #2953） */
  canPin: boolean
  /** 履歴のタイトルを編集できるか（企業・施主の両方。issue #2370） */
  canEditHistoryTitle: boolean
}

const PERMISSIONS: Record<SimulationRole, SimulationPermissions> = {
  company: {
    canEditCustomArea: true,
    canEditExcludeArea: true,
    canEditDealName: true,
    canUploadImage: true,
    canDeleteImage: true,
    canShare: true,
    canRegenerateMask: true,
    canConfigureCustomArea: true,
    canEditMaterial: true,
    canSelectPreset: true,
    canPin: true,
    canEditHistoryTitle: true,
  },
  customer: {
    canEditCustomArea: false,
    canEditExcludeArea: false,
    canEditDealName: false,
    canUploadImage: false,
    canDeleteImage: false,
    canShare: false,
    canRegenerateMask: false,
    canConfigureCustomArea: false,
    canEditMaterial: false,
    canSelectPreset: false,
    canPin: false,
    canEditHistoryTitle: true,
  },
}

/** roleから権限オブジェクトを取得する */
export function getPermissions(role: SimulationRole): SimulationPermissions {
  return PERMISSIONS[role]
}
